<div class="app-status-badge-container" [ngClass]="customClass">
  <!-- Optional Label (e.g. ORDER STATUS) -->
  <span *ngIf="label" class="app-status-badge-label">{{ label }}</span>

  <!-- Status Badge Pill Trigger -->
  <div
    class="draft-badge status-btn"
    [ngClass]="[
      currentStatusClass,
      'status-btn--' + size,
      isInteractive ? 'cursor-pointer' : 'status-btn--disabled'
    ]"
    [matMenuTriggerFor]="isInteractive ? statusMenu : null"
    (click)="onBadgeClick($event)"
    [attr.aria-disabled]="!isInteractive"
  >
    <div class="d-flex align-items-center justify-content-center">
      <span class="status-btn__text mb-0">{{ currentStatusDisplay }}</span>

      <!-- Dropdown Double Arrow / Chevron -->
      <div class="ms-1 d-flex align-items-center" *ngIf="showChevron && isInteractive">
        <svg
          width="10"
          height="11"
          viewBox="0 0 385 505"
          xmlns="http://www.w3.org/2000/svg"
          class="svg-icon"
        >
          <path
            d="M169.475 494.675C181.975 507.175 202.275 507.175 214.775 494.675L374.775 334.675C387.275 322.175 387.275 301.875 374.775 289.375C362.275 276.875 341.975 276.875 329.475 289.375L192.075 426.775L54.675 289.475C42.175 276.975 21.875 276.975 9.375 289.475C-3.125 301.975 -3.125 322.275 9.375 334.775L169.375 494.775L169.475 494.675Z"
            fill="currentColor"
          />
          <path
            d="M169.475 9.375C181.975 -3.125 202.275 -3.125 214.775 9.375L374.775 169.375C387.275 181.875 387.275 202.175 374.775 214.675C362.275 227.175 341.975 227.175 329.475 214.675L192.075 77.275L54.675 214.575C42.175 227.075 21.875 227.075 9.375 214.575C-3.125 202.075 -3.125 181.775 9.375 169.275L169.375 9.27501L169.475 9.375Z"
            fill="currentColor"
          />
        </svg>
      </div>
    </div>
  </div>

  <!-- Status Dropdown Menu (Matches 3-Dots Menu UI Theme - Clean list without icons) -->
  <mat-menu
    #statusMenu="matMenu"
    [xPosition]="xPosition"
    [yPosition]="yPosition"
    [class]="'app-status-menu-panel ' + menuClass"
  >
    <div class="app-status-menu__content">
      <button
        type="button"
        mat-menu-item
        *ngFor="let opt of cachedOptions; trackBy: trackByOption"
        class="app-status-menu__item"
        (click)="onSelect(opt)"
      >
        <span class="app-status-menu__item-label">{{ opt.label }}</span>
      </button>
    </div>
  </mat-menu>
</div>

